<template>
    <Bulletins :Mode="false" :Type="AppServiceID"></Bulletins>
</template>

<script>
import Vue from 'vue';
import Bulletins from '@/components/DPEBB/Administrator/Bulletins.vue'
import LayoutDefault from '../../Common/Default/DefaultLayout.vue';
export default {
    data: function(){
        return {
        AppServiceID :1,
        }
    },
    components: {

        Bulletins,

    },
created: function() {

    this.$emit('update:layout', LayoutDefault);
    this.AppServiceID = this.$store.getters.GetDentalID;
},    beforeCreate: function() {
        this.$store.dispatch('AddServiceID',this.$store.getters.GetDentalID);
        this.$store.dispatch('GetMenuItems',this.$store.getters.GetDentalID);
    },
}
</script>

<style>

</style>
